export type AnalyticsLocation = {
  latitude: number
  longitude: number
  location_coordinate: string
  area_bucket: string
}

// 小数点以下3桁 ≈ 110m: 正確な位置は記録せず、エリア単位の需要分析に足る精度
const COORDS_PRECISION = 3
const AREA_BUCKET_PRECISION = 2

const EARTH_RADIUS_METERS = 6371000

// アプリ（lodash の round）と同じく指数表記で桁をずらし、浮動小数点の誤差で丸め結果がずれないようにする
const round = (value: number, precision: number): number => {
  const [base, exponent = '0'] = `${value}`.split('e')
  const shifted = Math.round(Number(`${base}e${Number(exponent) + precision}`))
  const [shiftedBase, shiftedExponent = '0'] = `${shifted}`.split('e')

  return Number(`${shiftedBase}e${Number(shiftedExponent) - precision}`)
}

export const toAnalyticsLocation = (latitude: number, longitude: number): AnalyticsLocation => {
  const roundedLatitude = round(latitude, COORDS_PRECISION)
  const roundedLongitude = round(longitude, COORDS_PRECISION)
  const areaLatitude = round(latitude, AREA_BUCKET_PRECISION)
  const areaLongitude = round(longitude, AREA_BUCKET_PRECISION)

  return {
    latitude: roundedLatitude,
    longitude: roundedLongitude,
    location_coordinate: `${roundedLatitude.toFixed(COORDS_PRECISION)},${roundedLongitude.toFixed(
      COORDS_PRECISION
    )}`,
    area_bucket: `${areaLatitude.toFixed(AREA_BUCKET_PRECISION)},${areaLongitude.toFixed(
      AREA_BUCKET_PRECISION
    )}`,
  }
}

const toRadians = (degrees: number): number => degrees * (Math.PI / 180)

export const getDistanceInMeters = (
  latitude1: number,
  longitude1: number,
  latitude2: number,
  longitude2: number
): number => {
  const dLatitude = toRadians(latitude2 - latitude1)
  const dLongitude = toRadians(longitude2 - longitude1)
  const a =
    Math.sin(dLatitude / 2) * Math.sin(dLatitude / 2) +
    Math.cos(toRadians(latitude1)) *
      Math.cos(toRadians(latitude2)) *
      Math.sin(dLongitude / 2) *
      Math.sin(dLongitude / 2)

  return EARTH_RADIUS_METERS * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}
